import { FC } from 'react';
import styles from './QrLabelModal.module.scss';
import { PulseLogo } from '../PulseLogo';
import { QrCodeSvg } from '../QrCodeSvg';

export interface QrLabelModalProps {
  isOpen: boolean;
  onClose: () => void;
  type?: 'asset' | 'location';
}

export const QrLabelModal: FC<QrLabelModalProps> = ({
  isOpen,
  onClose,
  type = 'asset',
}) => {
  if (!isOpen) return null;

  const isLocation = type === 'location';

  return (
    <div className={styles.modal} onClick={onClose} role="dialog" aria-modal="true">
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.close} onClick={onClose} aria-label="Close modal">
          ×
        </button>
        <h2 className={styles.modalTitle}>
          {isLocation ? 'Pulse Location label' : 'Pulse Asset label'}
        </h2>
        
        <div className={styles.physicalLabel}>
          <div className={styles.labelBrand}>
            <PulseLogo variant="stamp" theme="light" />
            <span className={styles.labelCategory}>{isLocation ? 'Location' : 'Asset'}</span>
          </div>
          <h2>{isLocation ? 'Plant Room 01' : 'AHU-003'}</h2>
          <div className={styles.labelSub}>
            {isLocation ? 'Mechanical plant room' : 'Air Handling Unit'}
          </div>
          <div className={styles.labelBottom}>
            <div className={styles.qr}>
              <QrCodeSvg />
            </div>
            <div className={styles.labelSite}>
              Commerzbank
              <br />
              Building A · {isLocation ? 'Level 01' : 'Plant Room 01'}
            </div>
          </div>
        </div>

        <p className={styles.modalDescription}>
          A durable, restrained physical label that connects the {isLocation ? 'location' : 'equipment'} to its Pulse record.
        </p>
      </div>
    </div>
  );
};
